import { render, staticRenderFns } from "./SliderSwitch.vue?vue&type=template&id=79630499&"
import script from "./SliderSwitch.vue?vue&type=script&lang=js&"
export * from "./SliderSwitch.vue?vue&type=script&lang=js&"
import style0 from "./SliderSwitch.vue?vue&type=style&index=0&id=79630499&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports